import DisplayRemainingCharacters from "../Shared/DisplayRemainingCharacters";
import inputLimit from '../../utils/inputLimitConfig';

import styles from '../../styles/Components/Shared/ArticleForm.module.css';

const TrashIcon = '/static/img/SvgIcons/icons-trash-black.svg';

export default function Contributors ({ contributors, setContributors }) {

    const updateContributors = (prevContributors, name, value, idx) => {
        let updatedContributors = [];
        
        for (let i = 0; i < prevContributors.length; i++) {
            const currentData = prevContributors[i]
            const contributorData = i === idx ? { 
                [name]: value
            } : {}

            updatedContributors.push({
                ...currentData,
                ...contributorData
            })
        }

        return updatedContributors
    }

    const handleChange = (e, i) => {
        const { name, value } = e.target;

        setContributors(prevContributor => updateContributors(prevContributor, name, value, i))
    }

    const handleAddContributor = () => {
        setContributors(prevContributors => [
            ...prevContributors,
            {
                name: '',
                credentials: '',
                location: ''
            }
        ])
    }

    const removeRow = (index) => {
        setContributors(prevContributors => prevContributors.filter((_, i) => i !== index))
    }
    return  (
        <div className={styles.contributor_section}>
            <p>Contributors</p>
            {contributors.map((contributor, i) => (
                <div key={`contributor-${i}`} >
                    <div className={styles.contributor_header}>
                        <p>Contributor {i + 1}</p>
                        <button type="button" className={'button_text'} onClick={() => removeRow(i)}><img src={TrashIcon} alt="Trash Icon" /></button>
                    </div>
                    <div className={styles.contributor_row}>
                        <div>
                            <input
                                placeholder={`Enter name`}
                                className={`input_basic`}
                                type='text'
                                name='name'
                                value={contributor.name ? contributor.name : ''}
                                onChange={(e) => handleChange(e, i)}
                                maxLength={inputLimit.dps_contributors.name}
                            />
                            <DisplayRemainingCharacters
                                characterLimit={inputLimit.dps_contributors.name}
                                current={contributor.name}
                            />
                        </div>
                        <div>
                            <input
                                placeholder="Enter credentials"
                                className={`input_basic`}
                                type='text'
                                name='credentials'
                                value={contributor.credentials ? contributor.credentials : ''}
                                onChange={(e) => handleChange(e, i)}
                                maxLength={inputLimit.dps_contributors.credentials}
                            />
                            <DisplayRemainingCharacters
                                characterLimit={inputLimit.dps_contributors.credentials}
                                current={contributor.credentials}
                            />
                        </div>
                        <div className={styles.article_grid_span_2}>
                            <input
                                placeholder="Enter location"
                                className={`input_basic`}
                                type='text'
                                name='location'
                                value={contributor.location ? contributor.location : ''}
                                onChange={(e) => handleChange(e, i)}
                                maxLength={inputLimit.dps_contributors.location}
                            />
                            <DisplayRemainingCharacters
                                characterLimit={inputLimit.dps_contributors.location}
                                current={contributor.location}
                            />
                        </div>
                    </div>
                </div>
            ))}

            <button className={styles.add_contributor_button} type="button" onClick={handleAddContributor}>Add Contributor</button>
        </div>
    ) 
}